const filterData = {
  'Side to side with Squats Movements': {
    fields: ['Left', 'Right', 'Total', 'Squats'],
  },
  'Lateral Mobility/Weight Shifting with Squats Movements': {
    fields: ['Left', 'Right', 'Total', 'Squats'],
  },
  'Lateral Mobility/Weight Shifting no Squats Movements': {
    fields: ['Left', 'Right', 'Total'],
  },
  'Sitting LUE Functional Reach Movements': {
    fields: ['Total', 'Midline Crosses', 'Lateral Reaches'],
  },

  'Standing LUE Functional Reach Movements': {
    fields: ['Total', 'Midline Crosses', 'Lateral Reaches'],
  },

  'Standing RUE Functional Reach Movements': {
    fields: ['Total', 'Midline Crosses', 'Lateral Reaches'],
  },

  'Sitting RUE Functional Reach Movements': {
    fields: ['Total', 'Midline Crosses', 'Lateral Reaches'],
  },

  'Standing Activity Tolerance BUE Movements': {
    fields: ['Total Movements'],
    merge: true,
  },

  'Sitting Activity Tolerance BUE Movements': {
    fields: ['Total Movements'],
    merge: true,
  },
};

class MeasurementFilter {
  getFieldFromDataset(dataset, fieldName) {
    for (const index in dataset) {
      const currentData = dataset[index];

      if (currentData.name === fieldName) {
        return currentData.data;
      }
    }
  }

  filterDataSet(data, relevantFields) {
    const filtered = [];
    for (const index in data) {
      const currentData = data[index];

      if (relevantFields.includes(currentData.name)) {
        filtered.push(currentData);
      }
    }

    return filtered;
  }

  filterMeasurementData(measurement) {
    const relevantData = filterData[measurement.measurement_name];

    if (!relevantData) {
      return measurement;
    }

    const newMeasurement = { ...measurement };

    const relevantFields = relevantData.fields;
    const merge = relevantData.merge;
    const measurementData = newMeasurement.data;

    let filteredData;

    if (measurementData.length > 1) {
      let leftData;
      let rightData;
      if (merge) {
        leftData = this.getFieldFromDataset(measurementData[0], relevantFields[0]);
        rightData = this.getFieldFromDataset(measurementData[1], relevantFields[0]);

        const total = leftData + rightData;

        filteredData = [
          { name: 'Left Controller', data: leftData },
          { name: 'Right Controller', data: rightData },
          { name: 'Total', data: total },
        ];
        newMeasurement.controller_num = 1;
      } else {
        leftData = this.filterDataSet(measurementData[0], relevantFields);
        rightData = this.filterDataSet(measurementData[1], relevantFields);
        filteredData = [leftData, rightData];
      }
    } else {
      filteredData = this.filterDataSet(measurementData[0], relevantFields);
    }

    newMeasurement.data = [filteredData];

    return newMeasurement;
  }
}

export default MeasurementFilter;
